import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { UserId } from '../shared/userid.model';
import { AppInsightsService } from '../shared/AppInsights.Service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-identity-mgt-consultant',
  templateUrl: './identity-mgt-consultant.component.html',
  styleUrls: ['./identity-mgt-consultant.component.scss']
})
export class IdentityMgtConsultantComponent implements OnInit {
  public uid = '';
  public userId: string;
  public pwd: string;
  error: boolean;
  message: any;
  public resp: any;
  public showId = false;
  public showpwd = false;
  public forgot: any;
  public isLoading = false;
  public validate = true;
  public showPlaceholder: boolean;
  public errorFields: any = {
    uid: false
  };
  constructor(private router: Router, private forgotService: ForgotService, private appInsightsService: AppInsightsService, private httpclient: HttpClient,) {}

  @ViewChild('user') public user: ElementRef;
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  focusOnInput() {
    let setError = false;
	if (!!this.errorFields.uid) {
      setError = true;
      setTimeout(() => this.user.nativeElement.focus(), 0);
      setTimeout(() => this.user.nativeElement.select(), 0);
      window.scrollTo(0,this.user.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }
    return setError;
  }

  isErrorPresent() {
    if (!this.errorFields.uid) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['uid'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      isErrPresent = this.validatefields(fields[j]);
      if (isErrPresent) {
        break;
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }

  validatefields(model) {
    let error = false;
    this.validate = true;
    if (model === 'uid') {
      if (!this.uid) {
        this.errorFields.uid = true;
        error = true;
      } else {
        this.errorFields.uid = false;
      }
    }
    if (!!this.uid && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }
  ngOnInit() {
  	window.scroll(0,0);
  	this.showPlaceholder = true;
  	this.appInsightsService.logEvent("Forgot UI Page - Consultant");
    this.forgotService.getUid().subscribe(res => {
      this.userId = res;
      if (this.userId) {
        this.showId = true;
      }
    });
    this.forgotService.getType().subscribe(res => {
      this.pwd = res;
      if (this.pwd === 'pwd') {
        this.showpwd = true;
      }
    });
  }

  continue() {

    const user = new UserId();
    user.userId = this.uid;
    user.userType = 'consultant';
    const bodyString = JSON.stringify(user);
    if (!this.validateAllFields()) {
      setTimeout(() => {
        window.scroll(0, 0);
        this.error = false;
        this.isLoading = true;
        this.validate = true;
      });
      this.forgotService.getPassword(bodyString).subscribe( res => {
        this.forgot =  res;
        console.log("this.forgot data in consultant " + JSON.stringify(this.forgot));
        if (this.forgot) {       
          if (this.forgot.status_code && this.forgot.status_code !== '200') {
              setTimeout(() => {
	            this.isLoading = false;
	          });
              this.message = this.forgot.message;
              this.error = true;
              this.validate = false;
              window.scroll(0,0);
            } else {
                this.error = false;
                this.forgotService.setQuestions(this.forgot.questions);
                this.forgotService.setType('pwd');
                this.forgotService.setUserType(user.userType);
                console.log('window.location.origin ' +  window.location.origin);
					      console.log('redirecting url ' + this.forgot.url);
                if (this.forgot.url) {
                  window.location.href = window.location.origin + this.forgot.url;
                  console.log("window.location.href + " + window.location.href)
                } else {
                  this.router.navigate(['/questions']);
                }
            }
        }
      });
    } else {
    	this.focusOnInput();
    }
  }


  back() {
    this.router.navigate(['']);
  }

}
